import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const koTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: '이름 (소문자, 특수문자 불가)',
    add: '추가',
    allowedFileTypes: '허용되는 파일 형식',
    allowedFileTypesDescription:
      '허용되는 파일 형식을 제한합니다(예: 이미지/*, 애플리케이션/pdf). 모든 유형을 허용하려면 비워 두세요.',
    allowMultipleFiles: '여러 파일 허용',
    amountInCents: '센트 단위 금액',
    basePrice: '기본 가격',
    bcc: '숨은참조',
    brand: '브랜드',
    cc: 'CC',
    checkboxPlural: '체크박스 필드',
    checkboxSingular: '체크박스',
    checkedByDefault: '기본적으로 선택됨',
    chooseConfirmationType:
      '양식을 제출한 후 페이지에 메시지를 표시할지 아니면 다른 페이지로 리디렉션할지 선택합니다.',
    condition: '상태',
    confirmationMessage: '확인 메시지',
    confirmationType: '확인 유형',
    countryPlural: '국가 필드',
    countrySingular: '국가',
    creditCard: '신용카드',
    customURL: '맞춤 URL',
    datePlural: '날짜 필드',
    dateSingular: '날짜',
    defaultValue: '기본값',
    divide: '나누기',
    documentToLinkTo: '링크할 문서',
    doesNotEqual: '같지 않음',
    emailFrom: '이메일 보낸 사람',
    emailPlural: '이메일 필드',
    emailsDescription:
      '양식이 제출되면 맞춤 이메일을 보냅니다. 여러 수신자에게 동일한 이메일을 보내려면 쉼표로 구분된 목록을 사용하세요. 이 양식의 값을 참조하려면 해당 필드 이름을 이중 중괄호로 묶습니다(예: {{firstName}}). 와일드카드 {{*}}를 사용하여 모든 데이터를 출력하고 {{*:table}}을 사용하여 이메일에서 HTML 테이블 형식으로 지정할 수 있습니다.',
    emailSingular: '이메일',
    emailTo: '이메일 주소',
    equals: '같음',
    field: '필드',
    fields: '필드',
    fieldWidth: '필드 너비(백분율)',
    hasAnyValue: '모든 값이 있음',
    internalLink: '내부 링크',
    label: '라벨',
    maxFileSize: '최대 파일 크기(바이트)',
    maxFileSizeDescription: '최대 파일 크기(바이트)입니다. 제한 없이 비워 두세요.',
    message: '메시지',
    messageDescription: '이 이메일로 보내야 하는 메시지를 입력하세요.',
    messagePlural: '메시지 블록',
    messageSingular: '메시지',
    mimeType: 'MIME 유형',
    mimeTypePlural: 'MIME 유형',
    mimeTypeSingular: 'MIME 유형',
    multiply: '곱하기',
    numberPlural: '숫자 필드',
    numberSingular: '번호',
    optionPlural: '옵션',
    optionSingular: '옵션',
    paymentFieldPlural: '결제 분야',
    paymentFieldSingular: '결제',
    paymentProcessor: '결제 처리자',
    paymentStatus: '상태',
    placeholder: '자리 표시자',
    priceConditions: '가격 조건',
    priceConditionsPlural: '가격 조건',
    priceConditionsSingular: '가격조건',
    radioOptions: '라디오 속성 옵션',
    radioPlural: '무선장',
    radioSingular: '라디오',
    redirect: '리디렉션',
    replyTo: '답장하다',
    required: '필수',
    selectOptions: '옵션 선택',
    selectPlural: '필드 선택',
    selectSingular: '선택',
    statePlural: '상태 필드',
    stateSingular: '상태',
    staticValue: '정적 값',
    subject: '주제',
    submitButton: '제출 버튼 라벨',
    subtract: '빼기',
    textareaPlural: '텍스트 영역 필드',
    textareaSingular: '텍스트 영역',
    textPlural: '텍스트 필드',
    textSingular: '텍스트',
    title: '제목',
    token: '토큰',
    uploadCollection: '컬렉션 업로드',
    uploadCollectionDescription: '파일을 저장할 업로드 컬렉션을 선택하세요',
    uploadFieldPlural: '필드 업로드',
    uploadFieldSingular: '업로드',
    urlToRedirectTo: '리디렉션할 URL',
    value: '가치',
    valueOfField: '필드의 가치',
    valueType: '값 유형',
  },
}

export const ko: PluginLanguage = {
  dateFNSKey: 'ko',
  translations: koTranslations,
}
